import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import Chip from '@mui/material/Chip';
import Skeleton from '@material-ui/lab/Skeleton';
import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import api from '../../../../../services/api';
import NavegadorGestao from "../../../../../components/NavBarGestao";
import { Button } from "@material-ui/core";
import { format, addDays, isValid, parse } from 'date-fns';
import Tooltip from '@mui/material/Tooltip';
import moment from 'moment';
import {
    MaterialReactTable,

} from 'material-react-table';


import {
    DataGrid,  
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';






function novoServicoOperacional() {
    window.location.href = "/gestao/operacional/servicosoperacionais/cadastrar";

}

export default function ServicosOperacionais() {



    const [loading, setLoading] = useState(true);
    const [servicos, setServicos] = useState([]);


    async function listarInformacoes() {

        setLoading(true);

        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("v1/protected/servicooperacional/listartodos", {
                headers: headers
            }).then(function (response) {
                setServicos(response.data)

                setLoading(false);

            });


        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar Servicos opeacionais: " + _err)

        }

    }


    useEffect(() => {




        listarInformacoes();


    }, []);


const colunas = [
  {
    accessorKey: 'id_servico_operacao',
    header: 'ID',
    size: 50,
  },
   {
    accessorKey: 'nome',
    header: 'Nome',
    size: 150,
  },
  {
    accessorKey: 'descricao',
    header: 'Descricao',
    size: 400,
  },
  {
  accessorKey: 'fornecedor',
  header: 'Fornecedor',
  size: 300,
  Cell: ({ renderedCellValue }) => {
    const fornecedor = renderedCellValue;

    if (!fornecedor) return 'Fornecedor não informado';

    const isPessoaFisica = fornecedor.tipo_fornecedor === 0;

    const nome = isPessoaFisica
      ? `${fornecedor.nome || ''} ${fornecedor.sobrenome || ''}`
      : fornecedor.nome_fantasia || '';

    const documento = isPessoaFisica
      ? `CPF: ${fornecedor.cpf || 'N/A'}`
      : `CNPJ: ${fornecedor.cnpj || 'N/A'}`;

    const text = `ID: ${fornecedor.id_fornecedor || 'N/A'}\n${nome}\n${documento}`;

    return text;
  },
},

  
  {
    accessorKey: 'unidade_medida',
    header: 'Unidade',
    size: 100,
  },
  {
    accessorKey: 'periodo',
    header: 'Periodo',
    size: 100,
  },
  {
    accessorKey: 'periodicidade',
    header: 'Periodicidade',
    size: 100,
  },
  {
    accessorKey: 'valor_unitario',
    header: 'Valor Unitário',
    size: 100,
    Cell: ({ renderedCellValue }) => {
      return parseFloat(renderedCellValue).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
  {
    header: '',
    id: 'criado_por',
    size: 400,
    accessorFn: row => ({
      criador: row.usuario_criador,
      data: row.data_hora_criacao,
    }),
    Cell: ({ renderedCellValue }) => {
      const nome = renderedCellValue.criador.nome_amigavel;
      const data = moment(renderedCellValue.data, "YYYY-MM-DD HH:mm:ss");
      const dataFormatada = data.format("DD/MM/YYYY [às] HH:mm");
      return (
        <span style={{ fontSize: 14, color: 'black', fontWeight: 'bold' }}>
          adicionado por {nome} em {dataFormatada}
        </span>
      );
    }
  },
];



    return (
        <div>

            <NavegadorGestao
                Operacional={true}
                ServicosOperacionais={true}
                corFundo={'white'} travado={true} corTexto={'black'}
            />


            <div style={{ padding: 5, width: '100%', height: '100%' }}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="center"
                    item xs={12}
                >
                    <Button style={{ margin: 5 }}
                        variant="contained"
                        color="primary"
                        onClick={novoServicoOperacional}
                    >
                        Novo Serviço Operacional
                    </Button>
                </Grid>
                {loading ?
                    <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                    </Skeleton>
                    :

                    <div style={{ height: '100%', width: '100%' }}>
                      {servicos !== null && (
                     
                     
                     
                                                         <MaterialReactTable
                     
                                                             columns={colunas}
                                                             data={servicos}
                                                             enableTopToolbar={false}
                                                             enableBottomToolbar={false}
                                                             enablePagination={false}
                                                             enableColumnFilters={false}
                                                             enableColumnActions={false}
                                                             sortable={false}
                                                             enableRowActions={true}
                                                             enableSorting={false}
                                                             enableRowSelection={false}
                                                             color={'black'}
                                                             paginationDisplayMode={'pages'}
                                                             getRowId={(row) => row.id_servico_operacional}
                                                             initialState={{
                                                                 pagination: { pageSize: 20, pageIndex: 0 },
                                                                 showGlobalFilter: true,
                                                                 color: 'black'
                                                             }}
                                                             muiTableContainerProps={{ sx: { maxHeight: "3000px", color: 'black' } }}
                                                             muiTableBodyRowProps={{
                                                                 sx: {
                                                                     height: 55,
                                                                     color: 'black' // Define a cor do texto para preto
                                                                 },
                                                             }}
                                                             enableColumnFilterModes={false}
                                                             enableExpandAll={true}
                                                             enableColumnPinning={true}
                                                             enableColumnResizing={true}
                                                             muiPaginationProps={{
                                                                 rowsPerPageOptions: [20, 50, 100],
                                                                 variant: 'outlined',
                                                             }}
                                                             enableFullScreenToggle={true}
                                                             muiTablePaperProps={({ table }) => ({
                                                                 style: {
                                                                     zIndex: table.getState().isFullScreen ? 1000 : undefined,
                                                                     color: 'black',
                                                                 },
                                                             })}
                     
                                                            
                     
                     
                                                         />
                     
                     
                                                     )}
                    </div>
                }


            </div>



        </div>
    );
}



